// based on http://tiny.cc/unhover
document.addEventListener('touchend', () => undefined)
